import gql from 'graphql-tag';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  SearchWorkOrderIndex,
  SearchWorkOrderIndexVariables,
  SearchWorkOrderIndex_indextrious_searchTradePartnerWorkOrderIndex as WorkOrder,
} from '../../athena/types/SearchWorkOrderIndex';

export const SEARCH_WORK_ORDER_INDEX = gql`
  query SearchWorkOrderIndex(
    $filters: [OdProtosIndextriousData_FilterInput!]
    $page: OdProtosIndextriousData_PageParamsInput
    $sortBy: [OdProtosIndextriousData_SortByInput!]
    $aggregations: [OdProtosIndextriousData_AggregationInput!]
  ) {
    indextrious {
      searchTradePartnerWorkOrderIndex(
        input: { filters: $filters, page: $page, sortBy: $sortBy, aggregations: $aggregations }
      ) {
        size
        aggregations {
          key
          value {
            buckets {
              key
              count
            }
          }
        }
        results {
          id
          assignedToBranchId
          managedByBranchId
          workOrderScopeIds
          costCents
          acceptedCostCents
          lineItemIds
          scheduledStopAt
          scheduledStartAt
          dateRequestedAt
          address {
            uuid
            state
            street
            postalCode
            city
            country
            fullAddress
          }
          managerUserId
          managerContact {
            fullName
            primaryPhone
            email
          }
          market
          state
          progress
          inAllTab
          kind
          utilities {
            id
            activationDate
            currentlyActive
            deactivated
            kind
            notApplicable
          }
        }
      }
    }
  }
`;

export default buildQueryHook<
  SearchWorkOrderIndex,
  SearchWorkOrderIndexVariables,
  WorkOrder | null
>(SEARCH_WORK_ORDER_INDEX, {
  wrangler: (data) => data?.indextrious?.searchTradePartnerWorkOrderIndex ?? null,
});
